// extracted by mini-css-extract-plugin
export default {"toggle":"select_toggle__kghM-","dropdown":"select_dropdown__AvllS"};